export default __webpack_public_path__ + "static/media/heavy-duty.8421493e.jpg";